// Shared input validators usable on both the Node backend and the React/admin frontends.

// Mirrors the canonical regex in react/src/Helpers/formatting.js; also rejects common gmail typos.
const isValidEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase()) && ![/@gnail/, /@gmial/, /@gnial/, /@gmail\.(?!com$)/].some(typo => typo.test(email));
};

const MAX_ALLOWED_RETAILER_DOMAINS = 100;

const normalizeRetailerDomains = value => {
  const domains = new Set();
  const invalidEntries = [];
  const entries = (Array.isArray(value) ? value : (value || '').split(/[,\n]/)).filter(entry => typeof entry !== 'string' || entry.trim());
  if (entries.length > MAX_ALLOWED_RETAILER_DOMAINS) return { domains: [], invalidEntries: [], exceedsMaxDomains: true };
  entries.forEach(entry => {
    if (typeof entry !== 'string') return invalidEntries.push(String(entry));
    try {
      const url = new URL(entry.includes('://') ? entry.trim() : `https://${entry.trim()}`);
      const host = url.hostname.toLowerCase().replace(/^www\./, '');
      if (
        !['http:', 'https:'].includes(url.protocol) ||
        url.username ||
        url.password ||
        url.port ||
        host.length > 253 ||
        !/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(host)
      )
        throw new Error('Invalid domain');
      domains.add(host);
    } catch {
      invalidEntries.push(entry.trim());
    }
  });
  return { domains: [...domains], invalidEntries, exceedsMaxDomains: false };
};

const LEGAL_NAME_MAX_LENGTH = 40;

const normalizeLegalName = value =>
  String(value || '')
    .trim()
    .replace(/\s+/g, ' ');

const normalizeUsername = username => (typeof username === 'string' ? username.toLowerCase().replace(/[^a-z0-9_]/g, '') : '');

const getLegalNameFieldError = (value, { which = 'first', mode = 'submit' } = {}) => {
  const normalized = normalizeLegalName(value);
  if (!normalized) return mode === 'submit' ? `Enter your ${which === 'last' ? 'legal last name' : 'legal first name'}.` : null;
  if (normalized.length > LEGAL_NAME_MAX_LENGTH) return 'Keep this to 40 characters or fewer.';
  return null;
};

const getLegalNamesError = ({ legalFirstName, legalLastName, required = false } = {}) => {
  const first = normalizeLegalName(legalFirstName);
  const last = normalizeLegalName(legalLastName);
  if (!required && !first && !last) return null;
  return getLegalNameFieldError(first, { which: 'first', mode: 'submit' }) || getLegalNameFieldError(last, { which: 'last', mode: 'submit' });
};

module.exports = {
  isValidEmail,
  MAX_ALLOWED_RETAILER_DOMAINS,
  normalizeRetailerDomains,
  normalizeLegalName,
  normalizeUsername,
  getLegalNameFieldError,
  getLegalNamesError
};
